// extracted by mini-css-extract-plugin
export default {"input":"Search_input__3FYAJ","btn":"Search_btn__ETFkY"};